import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/services/mortgage-consultancy/MortgageConsultancyClient.jsx");
